import { mapGetters } from "vuex";
export default {
  data: () => ({
    isComplite: false,
    dialog: false,
    isAuth: false,
    select:{
      name: null,
      email: null,
      phone: null,
      id: null,
      title: null,
      type: null,
      text: null,
      file: null,
    },
    items: [
      { name: 'Бухгалтерия и платежи', value: 'payments' },
      { name: 'Ошибка в работе сайта', value: 'bug' },
      { name: 'Вопрос по работе системы', value: 'help' },
      { name: 'Модерация', value: 'moderation' },
      { name: 'Другое', value: 'other' },
    ],
  }),

  methods: {
    reset(isAuth) {
      this.dialog = !this.dialog;
      this.isComplite = false;
      this.isAuth = isAuth;
      this.select.name = null;
      this.select.email = null;
      this.select.phone = null;
      this.select.id = null;
      this.select.text = null;
      this.select.title = null;
      this.select.type = null;
      this.select.file = null;
    },
    modal(isAuth) { 
      this.reset(isAuth)
      this.$nextTick(() => {
        this.$refs.form.reset()
      })
    },
    closse(){
      this.dialog = false;
    },
    fileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      this.select.file = files[0];
    },
    send(){ 
      if (!this.$refs.form.validate()) {
        return
      }

      let formData = new FormData();
      for ( var key in this.select ) {
        formData.append(key, this.select[key]);
      }

      this.$axios.post('support', 
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      ).finally(() => {
        this.isComplite = true;
      });
    }
  },

  mounted() {
    this.$root.$on('modal.help', () => {
      let isAuth = false
      if(this.getUser){
        isAuth = true;
      }
      this.modal(isAuth);
    })
  },
  computed:{
    ...mapGetters(['getUser', 'rules']),
  },
  watch: {
    isComplite(to, from){
      if(to){
        setTimeout(()=>{
          this.reset(false)
        },3000);
      }
    },
  },
};


// WEBPACK FOOTER //
// ./src/modals/help/help.js